import styled from '@emotion/styled';
import { Image } from '$components/elements/image';

export const Splash = styled(Image)(() => ({
    maxWidth: '100%',
}));
